<template>
    <div class="Login">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Home"></navbar>
        <!--登录页-->
        <div class="Login_main">
            <div class="Login-page-content">
                <div class="Login_page">
                    <div class="log-reg-main">
                        <img class="ifree-logo" src="../../assets/home/new_home/logo_blue@2x.png">
                        <h1 class="login-title">
                            {{$t('user_center_already_account')}}
                        </h1>
                        <div class="login-main">
                            <div class="from-input">
                                <input class="login-email" type="text"
                                       :placeholder="$t('user_center_email')"
                                       name="email"
                                       v-validate="'required|email'"
                                       :class="{'is-error': errors.has('email')}"
                                       v-model="loginData.account">
                            </div>
                            <div class="from-input" style="position: relative">
                                <input class="login-password"
                                       type="password"
                                       :placeholder="$t('user_center_password')"
                                       name="password"
                                       v-validate="'required'"
                                       :class="{'is-error': errors.has('password')}"
                                       v-model="loginData.password" @keyup.enter="login">
                                <img v-if="showthis_1 === 'a'" src="../../assets/icon_eye.png" @click="hide()" width="30"
                                     style="position: absolute;right: 10px;top:25px;">
                                <img v-else-if="showthis_1 === 'b'" src="../../assets/icon_hide.png" @click="show()" width="30"
                                     style="position: absolute;right: 10px;top:25px;">
                            </div>
                            <div class="forget-psw">
                                <a @click="forget_psw">{{$t('user_center_forget_password')}}</a>
                            </div>
                            <div class="tip">
                                <p  style="font-size: 14px;color: #5E6D82;text-align: left;" >
                                    {{$t('login_agree')}}
                                    <router-link class="text-primary" :to="{name: 'terms_of_service'}">{{$t('agree_terms_of_conditions')}}</router-link>,
                                        <router-link :to="{name: 'privacy_policy'}" class="text-primary">{{$t('agree_privacy_policy')}}
                                    </router-link>
                                    {{$t('and')}}
                                    <router-link :to="{name: 'terms_of_law'}" class="text-primary">{{$t('agree_terms_of_law')}}</router-link>.
                                </p>
                            </div>

                            <div class="login-register-btn">
                                <button type="button" @click="login" >
                                    {{$t('user_center_login')}}
                                </button>
                            </div>
                            <div class="Option-group">
                                <div class="Option-part-one">
                                    <div class="FB-icon">
                                        <a>
                                            <img src="../../assets/facebook_c.png" width="50" @click="fblogin">
                                        </a>

                                    </div>
                                    <div class="WC-icon">
                                        <a href="http://officialapi.ifreegroup.co/wxlogin">
                                            <img src="../../assets/wechat_c.png" width="50">
                                        </a>
                                    </div>
                                    <div class="tip">
                                        <p style="text-align: center">{{$t('login_disan')}}</p>
                                    </div>
                                </div>
                            </div>
                            <div style="clear: both"></div>
                            <div class="tip">
                                    <a>
                                        <router-link :to="{name:'Register'}" class="text-primary">
                                            <p style="text-align: center">{{$t('login_tip')}}</p>
                                        </router-link>
                                    </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import dataImage from '../../lib/dataImage'
    import Signature from '../../lib/Signature'
    import modal from '../Common/Modal.vue'
    import navbar from '../Common/Navbar.vue'

    export default {
        data () {
            return {
                isTransparent:false,
                single1: false,
                showthis_1:'a',
                showthis_2:'a',
                wxlogin: 0,
                facebook_id:0,
                modal1:true,
                spinShow:false,
                spinShow_forget:false,
                loginData: {
                    account: '',
                    password: ''
                },
                registerData: {
                    username: '',
                    email: '',
                    password: '',
                    repassword: ''
                },
            }
        },
        components: {
            modal,navbar
        },
        methods: {
            //忘记密码
            forget_psw () {
                this.$forget.$emit('forget')
            },
            //登录密码显示与隐藏
            hide(id){
                    this.showthis_1 = 'b'
                    $('.login-password').attr('type','text')
            },
            show(id){
                    this.showthis_1 = 'a'
                    $('.login-password').attr('type','password')

            },
            //用户登录
            login () {
                if (this.single === false) {
                    this.$Message.error(this.$t('user_message_please_argee'))
                    return false
                }
                if(!this.loginData.account||!this.loginData.account){
                    this.$Message.error(this.$t('account_and_password'))
                    return false
                }

                let self = this
                const module = 'index.php/index/user/login'
                let data = {}
                data.account = self.loginData.account
                data.lang = this.$i18n.locale
                data.password = self.loginData.password
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.spinShow = true
                self.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2001) {
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                    if (parseInt(resp.data.code) === 2000) {
                        self.spinShow = false
                        self.$Message.success(resp.data.msg)
                        self.Local.set('users', resp.data.data)
                        let timestamp = Date.parse(new Date()) / 1000
                        self.Local.set('timeout', timestamp)
                        self.isLogin = true
                        //登录成功返回上一页
                        history.go(-1)
                    } else {
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                })
            },
            //facebook登录
            fblogin () {
                let vm = this
                FB.login(function (response) {
                    vm.statusChangeCallback(response)
                }, {
                    scope: 'email, public_profile',
                    return_scopes: true
                })
            },
            statusChangeCallback (response) {
                console.log(response)
                if (response.status === 'connected') {  //登陆状态已连接
                    this.fbToken = response.authResponse.accessToken
                    this.getUserInfo(this.fbToken)
                    this.facebook_id = 1
                }else if (response.status === 'underfind'){
                    location.reload()
                }else if (response.status === 'not_authorized') { //未经授权
                    console.log('facebook未经授权')
                    this.facebook_id = 0
                } else {
                    console.log('不是登陆到Facebook;不知道是否授权')
                    this.facebook_id = 0
                }
            },
            //获取登录状态
            checkLoginState () {
                FB.getLoginStatus(function (response) {
                    statusChangeCallback(response)
                })
            },
            //facebook登录
            third_login(third_resp,Token,type){
                let self = this
                const module = 'third_login'
                let data = {}
                data.uid = third_resp.id
                data.access_token = Token
                data.platform = type
                data.lang = self.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    console.log(resp.data)
                    if (parseInt(resp.data.code) === 2001) {
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                    if (parseInt(resp.data.code) === 6000) {
                        self.bind_email = true
                        self.platform_id = 1
                        self.cache_token = resp.data.data.cache_token
                    }
                    if (parseInt(resp.data.code) === 2000) {
                        self.$Message.success(resp.data.msg)
                        self.Local.set('users', resp.data.data)
                        let timestamp = Date.parse(new Date()) / 1000
                        self.Local.set('timeout', timestamp)
                        self.isLogin = true
                        //登录成功返回上一页
                        history.go(-1)
                    } else {
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                })
            },
            //wechat登录
            wechat_login() {
                let self = this
                const module = 'wxlogin'
                let data = {}
                data.wx_token=this.wxlogin
                data.lang = self.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    console.log(resp.data)
                    if (parseInt(resp.data.code) === 2001) {
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                    if (parseInt(resp.data.code) === 6000) {
                        self.bind_email = true
                        self.platform_id = 2
                        self.cache_token = resp.data.data.cache_token
                    }
                    if (parseInt(resp.data.code) === 2000) {
                        self.$Message.success(resp.data.msg)
                        self.Local.set('users', resp.data.data)
                        let timestamp = Date.parse(new Date()) / 1000
                        self.Local.set('timeout', timestamp)
                        self.isLogin = true
                        //登录成功返回上一页
                        history.go(-1)
                        self.facebook_login = 1
                    } else {
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                })
            },
            // 获取用户信息
            getUserInfo (fbToken) {
                let vm = this
                FB.api('/me', function (response) {
                    vm.third_login(response,fbToken,1)
                })
            }
        },
        mounted () {
            if (document.body.clientWidth < 920) {
                this.isTrans = false
            }
            window.addEventListener('scroll', this.change)

            console.log(this.Local.get('users'))

            //facebook login
            // facebook 初始化
            let vm = this
            window.fbAsyncInit = function() {
                FB.init({
                    appId: '386185291829616',
                    cookie: true,
                    xfbml: true,
                    version: 'v2.11'
                });
                FB.AppEvents.logPageView();

                // Get FB Login Status
                FB.getLoginStatus( response => {
                    vm.statusChangeCallback(response)
                })
            }

            //wechat 获取是否有wxlogin
            this.wxlogin = this.$route.query.wxlogin
            //调用wexlogin方法进行微信登录
            if(this.wxlogin){
                this.wechat_login()
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/_Login.scss";
</style>



// WEBPACK FOOTER //
// Login.vue?7de05e84